export const kdeDevices = require("./kdeneon_overlay-fs8.png");
export const kdeBG = require("./kde_neon_bg.png");
